import { Theme } from '@mui/material';
import { CSSObject } from '@mui/material/styles';

export const SHARED_DOCUMENTS_CARD_CLASS = 'shared-documents';
export const SHARED_DOCUMENTS_ITEM_CLASS = 'shared-documents__item';
export const SHARED_DOCUMENTS_STATUS_ICON_CLASS = 'shared-documents__status-icon';
export const SHARED_DOCUMENTS_UNVERIFIED_ICON_CLASS = 'shared-documents__status-icon--unverified';
export const SHARED_FILE_VERIFICATION_CLASS = 'shared-documents__verification';
export const SHARED_FILE_VERIFIED_CLASS = 'shared-documents__verified';
export const SHARED_FILE_BLOCKCHAIN_CLASS = 'shared-documents__blockchain';

/**
 * The page a share's recipient opens from their email: each shared file with whether it
 * is verified and, when it is, by whom, when and its blockchain record.
 *
 * Registered against `MuiPaper` in both palettes, like the licence-change dialog: the
 * page's card is a Paper, so the page only decides what it says.
 */
export const sharedDocumentsStyles = (theme: Theme): CSSObject => ({
	[`&.${SHARED_DOCUMENTS_CARD_CLASS}`]: {
		[`& .${SHARED_DOCUMENTS_ITEM_CLASS}`]: {
			alignItems: 'flex-start',
			gap: theme.spacing(1)
		},

		[`& .${SHARED_DOCUMENTS_ITEM_CLASS} .MuiListItemText-primary`]: {
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap'
		},

		// Level with the title's first line.
		[`& .${SHARED_DOCUMENTS_STATUS_ICON_CLASS}`]: {
			marginTop: theme.spacing(0.75),
			minWidth: 0
		},

		[`& .${SHARED_DOCUMENTS_UNVERIFIED_ICON_CLASS}`]: {
			color: theme.palette.text.secondary
		},

		[`& .${SHARED_FILE_VERIFICATION_CLASS}`]: {
			display: 'flex',
			flexDirection: 'column',
			gap: theme.spacing(0.25)
		},

		[`& .${SHARED_FILE_VERIFIED_CLASS}`]: {
			color: theme.palette.success.main,
			fontWeight: 600
		},

		// A transaction id is one long unbroken string.
		[`& .${SHARED_FILE_BLOCKCHAIN_CLASS}`]: {
			overflowWrap: 'anywhere'
		}
	}
});
